// Coach Daily Monitoring's `options` bag — Morning Brief today, `dailyReflection`
// added as a sibling key later (see msb-docs/morning-brief/morning-brief-implementation-plan.md Stage 0).
export const pullOptions = {
  morningBrief: { status: "draft", allowClientOverride: false },
};
